export default "__VITE_ASSET__xH$$1wtf__"